<app-modal
  #unsavedChanges
  [modalMessage]="app.text.app.confirmChanges"
  [showButtons]="false"
></app-modal>

<app-session-expires-modal
  #sessionExpires
  data-backdrop="static"
  data-keyboard="false"
  >
</app-session-expires-modal>

<div [ngClass]="{ 'app-container': !app.pcnGenerator.isPcnGenerator }">
  <div class="app-content">
    @if (app.error && !app.hasError) {
      <div
        class="error-notification top-bar"
        style="cursor: pointer"
        >
        <div class="container">
          <div class="p-1">
            <div class="col-md-2 pull-left">
              <i class="fa-solid fa-ban banIcon"></i>
            </div>
            <div class="col-md-10 pull-right">
              <div class="col-md-12 text-danger text-uppercase">
                {{ app.text.app.error }}
                <div class="close-btn pull-right" (click)="app.hasError = false">
                  <i class="fa fa-times"></i>
                </div>
              </div>
              <div class="col-md-12">
                {{ app.text.app.errorOccured }}
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (app.hasError) {
      <div
        class="error-notification top-bar"
        style="cursor: pointer"
        >
        <div class="container">
          <div class="p-1">
            <div class="col-md-2 pull-left">
              <i class="fa-solid fa-ban banIcon"></i>
            </div>
            <div class="col-md-10 pull-right">
              <div class="col-md-12 text-danger text-uppercase">
                {{ app.text.app.error }}
                <div class="close-btn pull-right" (click)="app.hasError = false">
                  <i class="fa fa-times"></i>
                </div>
              </div>
              <div class="col-md-12">
                {{ app.errorText }}
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- SUCCESS -->
    @if (app.hasSuccess) {
      <div
        class="success success-notification top-bar"
        style="cursor: pointer"
        >
        <div class="container">
          <div class="p-1">
            <div class="col-md-2 pull-left">
              <i class="fa-solid fa-octagon-check successIcon"></i>
            </div>
            <div class="col-md-10 pull-right">
              <div class="col-md-12 text-success text-uppercase">
                {{ app.text.app.success }}
                <div
                  class="close-btn pull-right"
                  (click)="app.hasSuccess = false"
                  >
                  <i class="fa fa-times"></i>
                </div>
              </div>
              <div class="col-md-12">
                {{ app.successText }}
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- LOADING -->
    <!-- <div *ngIf="app.busy" class="top-bar">
    <div class="container">
      <div class="p-1">
        <i class="fas fa-sync-alt spin spinner"></i>
        {{ app.text.app.loading }}
      </div>
    </div>
  </div> -->

  @if (!app.busy) {
    <div class="wrapper">
      <!-- Sidebar -->
      @if (!app.pcnGenerator.isPcnGenerator) {
        <div id="sidebar">
          <app-sidebar></app-sidebar>
        </div>
      }
      <!-- Page Contetnt -->
      <div
        id="content"
        [ngClass]="{ whiteBKGD: app.pcnGenerator.isPcnGenerator }"
        >
        <!-- Header -->
        @if (app.user != null) {
          <app-header></app-header>
        }
        <!-- Content -->
        <div class="container-fluid" [ngClass]="app.header.removePadding()">
          <router-outlet></router-outlet>
        </div>
      </div>
      <!-- Panel right -->
      <app-task-panel></app-task-panel>
      <!-- Backdrop for the grayed-out panel effect -->
      <div
        class="backdropPanel"
        [class.active]="app.taskPanel.isOpen"
        (click)="app.taskPanel.closePanel()"
      ></div>
      <!-- Filters -->
      <div id="filters">
        <!-- Filters OM -->
        @if (app.filterList.open) {
          <div id="collapseFilter" class="filter">
            <app-filter [types]="types"></app-filter>
          </div>
        }
        <!-- Filters RM -->
        @if (app.RM.filterOpen) {
          <div id="collapseFilter" class="filter">
            <app-filter-tree></app-filter-tree>
          </div>
        }
        <!-- Filters Dashboard -->
        @if (app.filterDashboard.isOpen) {
          <div
            id="collapseFilter"
            class="filter"
            >
            <app-filter-dashboard></app-filter-dashboard>
          </div>
        }
      </div>
      <!-- Side view of creation of the user  -->
      @if (app.users.creationOpen) {
        <div
          id="userCreation"
          class="userCreation"
          >
          <div id="collapseCreation">
            <app-user></app-user>
          </div>
        </div>
      }
      @if (app.profile.viewProfile) {
        <div id="profileView" class="profile">
          <div id="collapseProfileView">
            <app-profile></app-profile>
          </div>
        </div>
      }
      @if (app.auth.entraBenefitsOpen) {
        <div
          id="entraIdBenefitsView"
          class="entraBenefits"
          >
          <div id="collapseEntraBenefits">
            <div class="row p-3 mt-4">
              <div class="col-md-12">
                <h4>Microsoft Entra ID</h4>
                <p>
                  {{ app.getText("user.entraSubtext") }}
                </p>
                <ul class="unlinked">
                  <li>
                    <i class="fa-solid fa-right-to-bracket colorize"></i>
                    <div class="li-content">
                      <div class="li-title">
                        {{ app.getText("user.entraSection1Title") }}
                      </div>
                      <div class="li-text">
                        {{ app.getText("user.entraSection1Text") }}
                      </div>
                    </div>
                  </li>
                  <li>
                    <i class="fa-solid fa-user-lock colorize"></i>
                    <div class="li-content">
                      <div class="li-title">
                        {{ app.getText("user.entraSection2Title") }}
                      </div>
                      <div class="li-text">
                        {{ app.getText("user.entraSection2Text") }}
                      </div>
                    </div>
                  </li>
                  <li>
                    <i class="fa-solid fa-shield-halved colorize"></i>
                    <div class="li-content">
                      <div class="li-title">
                        {{ app.getText("user.entraSection3Title") }}
                      </div>
                      <div class="li-text">
                        {{ app.getText("user.entraSection3Text") }}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      }
      <!-- Release Notes Banner -->
      <app-release-notes-banner> </app-release-notes-banner>
    </div>
  }
</div>
</div>

<div class="app-footer">
  <app-footer></app-footer>
</div>

<ngx-spinner size="medium" type="ball-atom" [fullScreen]="true">
  <p class="spinner-text">Loading ...</p>
</ngx-spinner>
